export default __webpack_public_path__ + "static/media/logo_rer.6d72680e.svg";